export type LanguageFieldValue = string;
export type InvitationFieldValue = string | undefined;

export const languagePreviouslySelectedLocalStorageKey =
  'account.dashboard.invite.previousSelectedLocales';
